// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__oL96U","buttons":"styles_buttons__2ueQm"};